var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6L14.7991 11.5289C14.8628 11.5907 14.9133 11.6642 14.9478 11.745C14.9823 11.8258 15 11.9125 15 12C15 12.0875 14.9823 12.1742 14.9478 12.255C14.9133 12.3358 14.8628 12.4093 14.7991 12.4711L9 18",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgNkwxNC43OTkxIDExLjUyODlDMTQuODYyOCAxMS41OTA3IDE0LjkxMzMgMTEuNjY0MiAxNC45NDc4IDExLjc0NUMxNC45ODIzIDExLjgyNTggMTUgMTEuOTEyNSAxNSAxMkMxNSAxMi4wODc1IDE0Ljk4MjMgMTIuMTc0MiAxNC45NDc4IDEyLjI1NUMxNC45MTMzIDEyLjMzNTggMTQuODYyOCAxMi40MDkzIDE0Ljc5OTEgMTIuNDcxMUw5IDE4IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjcxNDI5IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";